import each from 'lodash/each';

export const getOnlineParticipants = (presenceData) => {
  const returnedData = {};

  each(presenceData, (value) => {
    if (!value.user) return;

    const userId = value.user.replace(/.+-/, '');
    returnedData[`id-${userId}`] = true;
  });

  return returnedData;
};
